import React, { useState, Context, ReactElement, Component } from "react";
import { clusters_type_item } from "./clusters";

export interface clusters_for_page_type {
    clusters_for_dedicate_clusters_page?: clusters_type_item[];
    clusters_for_shared_clusters_page?: clusters_type_item[];
    clusters_for_dedicate_workspaces_page?: clusters_type_item[];
    clusters_for_shared_workspaces_page?: clusters_type_item[];
    clusters_for_dedicate_namespaces_page?: clusters_type_item[];
    clusters_for_shared_namespaces_page?: clusters_type_item[];
    clusters_for_nodes_page?: clusters_type_item[];
    clusters_for_monitor_page?: clusters_type_item[];
    clusters_for_workspace_quotas_page?: clusters_type_item[];
    clusters_for_serviceUsage_page?: clusters_type_item[];
  }

const ClustersForPageContext: Context<[clusters_for_page_type | undefined, React.Dispatch<React.SetStateAction<clusters_for_page_type | undefined>>]> = React.createContext<[clusters_for_page_type | undefined, React.Dispatch<React.SetStateAction<clusters_for_page_type | undefined>>]>([undefined, (_value: any) => { }]);

const ClustersForPageProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [clusters_for_page, set_clusters_for_page]: [clusters_for_page_type | undefined, React.Dispatch<React.SetStateAction<clusters_for_page_type | undefined>>] = useState<clusters_for_page_type | undefined>();
    return (
        <ClustersForPageContext.Provider value={[clusters_for_page, set_clusters_for_page]}>
            {props.children}
        </ClustersForPageContext.Provider>
    )
}

export { ClustersForPageContext, ClustersForPageProvider };

